import { render, staticRenderFns } from "./GraficaCostosTransporte.vue?vue&type=template&id=ff28705a"
import script from "./GraficaCostosTransporte.vue?vue&type=script&lang=js"
export * from "./GraficaCostosTransporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports